import axios from 'axios'
// import Vuetify from 'vuetify'

/**
 * Per accedere globalmente a questo modulo usare rootState, rootGetters negli altri moduli
 * 
 * Esempio:
 * getters: {
 *  getRoute(state, getters, rootState) {
 *    return rootState.route;
 *   }
 * }
 */

export default {
	namespaced: true,
	
	state: {
		isRunning: false,
		showStep: true,
		startManually: false,
		
		/**
		 * TODO: dare delle classi specifiche e parlanti per ogni gruppo di steps
		 *  Esempi:
		 *  tour-step-intro-, ...
		 * 	tour-step-pratica-inail, ...
		 * 	tour-step-pratica-inail-click, ...
		 * 	tour-step-end, ...
		 */
		introTourSteps: [
			// {
			// 	target: '.tour-step-1',
			// 	content: `Benvenuto, segui questa breve guida per scoprire quanto è semplice usare il Click day Manager!<br><br>
      //       Se non l'hai ancora fatto, salva subito le tue credenziali di accesso in un posto sicuro.<br><br>
      //       Guarda questa sezione nel riquadro blu: puoi trovare i dati di contatto del tuo Referente del Servizio Clienti, salvali in rubrica se non l'hai ancora fatto!<br><br>
			// 			<span style="color: #ffff00">Clicca su "Successivo"</span> per continuare la guida.`,
			// 	params: {
			// 		highlight: true,
			// 		placement: 'left-start'
			// 	}
			// },
			{
				target: '.tour-step-benvenuto',
				content: `Benvenuto, segui questa breve guida per scoprire quanto è semplice usare il Click day Manager!<br><br>
						<span style="color: #ffff00">Clicca su "Successivo"</span> per continuare la guida.`,
				params: {
					highlight: true,
					placement: 'bottom-start'
				}
			},
			{
				target: '.tour-step-2',
				content: `Cliccando qui potrai scaricare una copia del tuo Accordo di Prenotazione e tutto il materiale informativo e divulgativo per spiegare ai tuoi clienti cos’è e come funziona il Click Day.`,
				params: {
					highlight: true,
					placement: 'right-start'
				}
			},
			{
				target: '.tour-step-3',
				content: `Cliccando su questo pulsante puoi gestire le tue pratiche e vederne tutti i dettagli.`,
				params: {
					highlight: true,
					placement: 'left-start'
				}
			},
			{
				target: '.tour-step-utente-bando',
				content: `In questa sezione puoi visualizzare il tuo nome Utente e il tipo di Bando su cui è impostato il ClickDayManager e che stai visionando.`,
				params: {
					highlight: true,
					placement: 'bottom'
				}
			},
			{
				target: '.tour-step-impostazioni',
				content: `Se hai partecipato a più Click Day con noi, puoi cambiare il Bando cliccando qui su “Impostazioni”.<br><br>
						Nella schermata che vedrai potrai selezionare dal menù a tendina il Bando che vuoi impostare e visionare.<br>
						Ricorda, dopo avere selezionato il Bando, di cliccare su “Salva” prima di uscire.`,
				params: {
					highlight: true,
					placement: 'bottom'
				}
			},
			{
				target: '.tour-step-4',
				content: `Puoi accedere al materiale informativo velocemente anche cliccando questa voce del menù.`,
				params: {
					highlight: true,
					placement: 'bottom'
				}
			},
			{
				target: '.tour-step-5',
				content: `E da qui puoi accedere velocemente alle tue pratiche.`,
				params: {
					highlight: true,
					placement: 'bottom'
				}
			},
			{
				target: '.tour-step-menu-contratti-di-servizio',
				content: `Qui trovi la sezione relativa ai Contratti di Servizio, con le pratiche suddivise in base ai contratti caricati.<br><br>
					Se sei un consulente, potrai visualizzare i contratti che hai firmato o fatto firmare alle aziende clienti.`,
				params: {
					highlight: true,
					placement: 'bottom-end'
				},
				offset: 48
			},
			{
				target: '.tour-step-6',
				content: `Se vuoi chiudere il Click Day Manager clicca su "Esci".<br><br>
						Al prossimo accesso dovrai inserire nuovamente le tue credenziali di accesso.`,
				params: {
					highlight: true,
					placement: 'bottom'
				}
			},
			{
				target: '.tour-step-7',
				content: `Cliccando su questo interruttore puoi scegliere il colore dello sfondo dell'app: bianco o nero!<br><br>
						Consigliamo il bianco nelle ore diurne e il nero nelle ore serali per non appesantire la vista ;)`, // TODO: Faccina occhiolino
				params: {
					highlight: true,
					placement: 'bottom'
				}
			},
			{
				target: '.tour-step-8',
				content: `Entra nella Gestione Pratiche per continuare la Guida!<br><br>
						<span style="color: #ffff00">Clicca sul pulsante!</span>`,
				params: {
					highlight: true,
					placement: 'top'
				},
				offset: 48
			},
			{
				target: '.tour-step-9',
				content: `Questa tabella mostra la pratica (o le pratiche) da inviare il giorno del ClickDay.`,
				params: {
					highlight: true,
					placement: 'top'
				},
				offset: 48
			},
			{
				target: '.tour-step-10',
				content: `In questa colonna trovi l'ID della pratica, ovvero il numero identificativo che abbiamo assegnato ad ogni pratica che invieremo il giorno del Click Day.<br><br>
						Utilizza questo numero per identificare subito una pratica con il tuo Account Manager<br><br>
						1/2`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-11',
				content: `Questa colonna, come tutte le altre che hanno la freccetta sull'intestazione, può essere ordinata semplicemente cliccando sul titolo.<br><br>
						In questo modo i dati nella colonna si riorganizzano in base all'ordinamento selezionato. I valori verranno disposti in ordine crescente o decrescente a seconda della freccetta.<br><br>
						2/2`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-12',
				content: `In queste colonne appariranno i dati della pratica che inserirà il tuo Account Manager estrapolandoli dai documenti che caricherai in questo gestionale.<br><br>
						Anche in questo caso puoi ordinare la tabella cliccando sull'intestazione di ogni colonna!`,
				params: {
					highlight: true,
					placement: 'bottom-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-13',
				content: `Ogni pratica segue delle fasi di avanzamento. Qui puoi vedere velocemente lo stato di avanzamento della pratica.<br><br>
						Le fasi in blu sono quelle non completate. Quando una fase è stata completata e validata diventerà verde!<br><br>
						1/2`,
				params: {
					highlight: true,
					placement: 'left-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-14',
				content: `Quando c'è un aggiornamento su una fase della pratica, apparirà un pallino arancione in alto per avvisarti di controllare lo stato di avanzamento della fase.<br><br>
						Cliccando su ogni fase puoi vederne il dettaglio!`,
				params: {
					highlight: true,
					placement: 'left-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-15',
				content: `Qui puoi vedere la data in cui ogni pratica è stata creata.`,
				params: {
					highlight: true,
					placement: 'left-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-16',
				content: `Qui invece vedi la data in cui è stato fatto l'ultimo aggiornamento della pratica.`,
				params: {
					highlight: true,
					placement: 'left-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-17',
				content: `Cliccando su questa icona puoi entrare dentro la pratica e vederne il dettaglio di ogni fase.<br><br>
						<span style="color: #ffff00">Clicca subito sull'icona per continuare la guida!</span>`,
				params: {
					highlight: true,
					placement: 'left-start'
				},
				offset: 48
			}
		],
		
		praticaINAILTourSteps: [
			{
				target: '.tour-step-18',
				content: `Ecco siamo dentro una pratica!<br><br>
						Questo pannello ti permette di vedere le fasi di ogni pratica.<br><br>
						Ora siamo nella Fase 1: "CARICA I DATI DELLA PRATICA"<br><br>
						Cliccando su ogni fase potrai vedere il dettaglio, caricare i documenti richiesti e controllare lo stato di avanzamento.`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-19',
				content: `Qui puoi vedere lo STATO di ogni fase.<br><br>
						Quando lo stato di ogni fase viene cambiato vuol dire che c'è un avanzamento della pratica, per questo motivo verrai avvisato con una notifica tramite email e potrai entrare nella pratica per controllare.`,
				params: {
					highlight: true,
					placement: 'bottom'
				},
				offset: 48
			},
			{
				target: '.tour-step-20',
				content: `Leggi con attenzione ogni descrizione di ogni fase che ti informa sui punti principali che devi conoscere e/o eseguire per procedere al meglio con la tua pratica!`,
				params: {
					highlight: true,
					placement: 'bottom'
				},
				offset: 48
			},
			
			{
				target: '.tour-step-21',
				content: `Per esempio, in questa <b>Fase 1 "CARICA I DATI DELLA PRATICA"</b> ti chiediamo di caricare tutti i documenti e i dati richiesti appena possibile, seguendo le indicazioni.<br><br>
						In questo modo potremo procedere con le altre fasi, dare al cliccatore i tuoi dati per allenarsi e prepararci al meglio per vincere il Click Day!`,
				params: {
					highlight: true,
					placement: 'top'
				},
				offset: 48
			},
			{
				target: '.tour-step-22',
				content: `Ora siamo nella Fase 2: RIEPILOGO DEI DATI DELLA PRATICA<br><br>
						In questa sezione puoi controllare i dati che verranno caricati dal tuo Account Manager estrapolandoli dai documenti che hai caricato nella fase precedente e che serviranno al cliccatore per allenarsi al meglio!<br><br>
						<span style="color: #ffff00">Clicca sulla Fase 3 per procedere con la guida</span>`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-23',
				content: `Nella Fase 3 troverai il calendario aggiornato delle date del ClickDay.<br><br>
						<span style="color: #ffff00">Clicca sulla prossima Fase!</span>`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-24',
				content: `In questa Fase 4 potrai verificare quando ti sarà assegnato il cliccatore.<br><br>
						<span style="color: #ffff00">Vai alla prossima Fase!</span>`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-25',
				content: `Controlla questa Fase per rimanere aggiornato sull'allenamento del cliccatore a te assegnato!<br><br>
						<span style="color: #ffff00">Continua la guida cliccando sulla Fase 6!</span>`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-26',
				content: `In questa Fase 6 potrai controllare la registrazione al Portale Partecipante del cliccatore e vedere lo Screenshot.<br><br>
						<span style="color: #ffff00">Clicca sulla prossima Fase!</span>`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
			{
				target: '.tour-step-27',
				content: `Qui caricheremo lo Screenshot della schermata del cliccatore entro 48 ore dal Click Day.<br><br>
						<span style="color: #ffff00">Prosegui cliccando sulla Fase 8.</span>`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
			{
				target: '.tour-step-28',
				content: `Qui ti mostreremo gli elenchi cronologici non appena saranno pubblicati sul sito dell'INAIL.<br><br>
						<span style="color: #ffff00">Vai all'ultima fase!</span>`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
			{
				target: '.tour-step-29',
				content: `In questa ultima Fase 9 potrai consultare lo stato della tua fattura.<br><br>
						<span style="color: #ffff00">Clicca sul pulsante "Chiudi"</span> in basso a destra per chiudere la schermata con le Fasi e tornare alla tabella con le pratiche.`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
		],
		
		praticaVIMTourSteps: [
			{
				target: '.tour-step-18',
				content: `Ecco siamo dentro una pratica!<br><br>
						Questo pannello ti permette di vedere le fasi di ogni pratica.<br><br>
						Ora siamo nella Fase 1: "CARICA I DATI DELLA PRATICA"<br><br>
						Cliccando su ogni fase potrai vedere il dettaglio, caricare i documenti richiesti e controllare lo stato di avanzamento.`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-19',
				content: `Qui puoi vedere lo STATO di ogni fase.<br><br>
						Quando lo stato di ogni fase viene cambiato vuol dire che c'è un avanzamento della pratica, per questo motivo verrai avvisato con una notifica tramite email e potrai entrare nella pratica per controllare.`,
				params: {
					highlight: true,
					placement: 'bottom'
				},
				offset: 48
			},
			{
				target: '.tour-step-20',
				content: `Leggi con attenzione ogni descrizione di ogni fase che ti informa sui punti principali che devi conoscere e/o eseguire per procedere al meglio con la tua pratica!`,
				params: {
					highlight: true,
					placement: 'bottom'
				},
				offset: 48
			},
			
			{
				target: '.tour-step-21',
				content: `Per esempio, in questa <b>Fase 1 "CARICA I DATI DELLA PRATICA"</b> ti chiediamo di caricare tutti i documenti e i dati richiesti appena possibile, seguendo le indicazioni.<br><br>
						In questo modo potremo procedere con le altre fasi, dare al cliccatore i tuoi dati per allenarsi e prepararci al meglio per vincere il Click Day!`,
				params: {
					highlight: true,
					placement: 'top'
				},
				offset: 48
			},
			{
				target: '.tour-step-22',
				content: `Ora siamo nella Fase 2: RIEPILOGO DEI DATI DELLA PRATICA<br><br>
						In questa sezione puoi controllare i dati che verranno caricati dal tuo Account Manager estrapolandoli dai documenti che hai caricato nella fase precedente e che serviranno al cliccatore per allenarsi al meglio!<br><br>
						<span style="color: #ffff00">Clicca sulla Fase 3 per procedere con la guida</span>`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-23',
				content: `In questa Fase 3 potrai verificare quando ti sarà assegnato il cliccatore.<br><br>
						<span style="color: #ffff00">Vai alla prossima Fase!</span>`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-24',
				content: `Qui caricheremo lo Screenshot della schermata del cliccatore entro 48 ore dal Click Day.<br><br>
						<span style="color: #ffff00">Prosegui cliccando sulla Fase 5.</span>`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
			{
				target: '.tour-step-25',
				content: `Qui ti mostreremo gli elenchi cronologici non appena saranno pubblicati sul sito dell'INAIL.<br><br>
						<span style="color: #ffff00">Vai all'ultima fase!</span>`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
			{
				target: '.tour-step-26',
				content: `In questa ultima Fase 6 potrai consultare lo stato delle tue fatture.<br><br>
						<span style="color: #ffff00">Clicca sul pulsante "Chiudi"</span> in basso a destra per chiudere la schermata con le Fasi e tornare alla tabella con le pratiche.`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
		],
		
		praticaVoucherCloudECybersecurityTourSteps: [
			{
				target: '.tour-step-18',
				content: `Ecco siamo dentro una pratica!<br><br>
						Questo pannello ti permette di vedere le fasi di ogni pratica.<br><br>
						Ora siamo nella Fase 1: "CARICA I DATI DELLA PRATICA"<br><br>
						Cliccando su ogni fase potrai vedere il dettaglio, caricare i documenti richiesti e controllare lo stato di avanzamento.`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-19',
				content: `Qui puoi vedere lo STATO di ogni fase.<br><br>
						Quando lo stato di ogni fase viene cambiato vuol dire che c'è un avanzamento della pratica, per questo motivo verrai avvisato con una notifica tramite email e potrai entrare nella pratica per controllare.`,
				params: {
					highlight: true,
					placement: 'bottom'
				},
				offset: 48
			},
			{
				target: '.tour-step-20',
				content: `Leggi con attenzione ogni descrizione di ogni fase che ti informa sui punti principali che devi conoscere e/o eseguire per procedere al meglio con la tua pratica!`,
				params: {
					highlight: true,
					placement: 'bottom'
				},
				offset: 48
			},
			
			{
				target: '.tour-step-21',
				content: `Per esempio, in questa <b>Fase 1 "CARICA I DATI DELLA PRATICA"</b> ti chiediamo di caricare tutti i documenti e i dati richiesti appena possibile, seguendo le indicazioni.<br><br>
						In questo modo potremo procedere con le altre fasi, dare al cliccatore i tuoi dati per allenarsi e prepararci al meglio per vincere il Click Day!`,
				params: {
					highlight: true,
					placement: 'top'
				},
				offset: 48
			},
			{
				target: '.tour-step-22',
				content: `Ora siamo nella Fase 2: RIEPILOGO DEI DATI DELLA PRATICA<br><br>
						In questa sezione puoi controllare i dati che verranno caricati dal tuo Account Manager estrapolandoli dai documenti che hai caricato nella fase precedente e che serviranno al cliccatore per allenarsi al meglio!<br><br>
						<span style="color: #ffff00">Clicca sulla Fase 3 per procedere con la guida</span>`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-23',
				content: `In questa Fase 3 potrai verificare quando ti sarà assegnato il cliccatore.<br><br>
						<span style="color: #ffff00">Vai alla prossima Fase!</span>`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-24',
				content: `Qui caricheremo lo Screenshot della schermata del cliccatore entro 48 ore dal Click Day.<br><br>
						<span style="color: #ffff00">Prosegui cliccando sulla Fase 5.</span>`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
			{
				target: '.tour-step-25',
				content: `Qui ti mostreremo gli elenchi cronologici non appena saranno pubblicati sul sito del MIMIT.<br><br>
						<span style="color: #ffff00">Vai all'ultima fase!</span>`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
			{
				target: '.tour-step-26',
				content: `In questa ultima Fase 6 potrai consultare lo stato della tua fattura.<br><br>
						<span style="color: #ffff00">Clicca sul pulsante "Chiudi"</span> in basso a destra per chiudere la schermata con le Fasi e tornare alla tabella con le pratiche.`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
		],
		
		praticaISMEATourSteps: [
			{
				target: '.tour-step-18',
				content: `Ecco siamo dentro una pratica!<br><br>
						Questo pannello ti permette di vedere le fasi di ogni pratica.<br><br>
						Ora siamo nella Fase 1: "CARICA I DATI DELLA PRATICA"<br><br>
						Cliccando su ogni fase potrai vedere il dettaglio, caricare i documenti richiesti e controllare lo stato di avanzamento.`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-19',
				content: `Qui puoi vedere lo STATO di ogni fase.<br><br>
						Quando lo stato di ogni fase viene cambiato vuol dire che c'è un avanzamento della pratica, per questo motivo verrai avvisato con una notifica tramite email e potrai entrare nella pratica per controllare.`,
				params: {
					highlight: true,
					placement: 'bottom'
				},
				offset: 48
			},
			{
				target: '.tour-step-20',
				content: `Leggi con attenzione ogni descrizione di ogni fase che ti informa sui punti principali che devi conoscere e/o eseguire per procedere al meglio con la tua pratica!`,
				params: {
					highlight: true,
					placement: 'bottom'
				},
				offset: 48
			},
			
			{
				target: '.tour-step-21',
				content: `Per esempio, in questa <b>Fase 1 "CARICA I DATI DELLA PRATICA"</b> ti chiediamo di caricare tutti i documenti e i dati richiesti appena possibile, seguendo le indicazioni.<br><br>
						In questo modo potremo procedere con le altre fasi, dare al cliccatore i tuoi dati per allenarsi e prepararci al meglio per vincere il Click Day!`,
				params: {
					highlight: true,
					placement: 'top'
				},
				offset: 48
			},
			{
				target: '.tour-step-22',
				content: `Ora siamo nella Fase 2: RIEPILOGO DEI DATI DELLA PRATICA<br><br>
						In questa sezione puoi controllare i dati che verranno caricati dal tuo Account Manager estrapolandoli dai documenti che hai caricato nella fase precedente e che serviranno al cliccatore per allenarsi al meglio!<br><br>
						<span style="color: #ffff00">Clicca sulla Fase 3 per procedere con la guida</span>`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-23',
				content: `In questa Fase potrai verificare quando ti sarà assegnato il cliccatore.<br><br>
						<span style="color: #ffff00">Vai alla prossima Fase!</span>`,
				params: {
					highlight: true,
					placement: 'right-start'
				},
				offset: 48
			},
			{
				target: '.tour-step-24',
				content: `Qui caricheremo lo Screenshot della schermata del cliccatore entro 48 ore dal Click Day.<br><br>
						<span style="color: #ffff00">Prosegui cliccando sulla Fase 5.</span>`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
			{
				target: '.tour-step-25',
				content: `In questa Fase potrai caricare il file allegato alla PEC ricevuta dall’ente ISMEA contenente l’esito della domanda.<br><br>
						<span style="color: #ffff00">Vai all'ultima fase!</span>`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
			{
				target: '.tour-step-26',
				content: `In questa ultima Fase potrai consultare lo stato della tua fattura.<br><br>
						<span style="color: #ffff00">Clicca sul pulsante "Chiudi"</span> in basso a destra per chiudere la schermata con le Fasi e tornare alla tabella con le pratiche.`,
				params: {
					highlight: true,
					placement: 'right-end'
				},
				offset: 48
			},
		],
		
		// contrattoDiServizioTourSteps: [
		// 	{
		// 		target: '.tour-step-30',
		// 		content: `Qui trovi la sezione relativa ai Contratti di Servizio, con le pratiche suddivise in base ai contratti caricati.<br><br>
		// 			Se sei un consulente, potrai visualizzare i contratti che hai firmato o fatto firmare alle aziende clienti.`,
		// 		params: {
		// 			highlight: true,
		// 			placement: 'bottom-end'
		// 		},
		// 		offset: 48
		// 	},
		// ],
		
		endTourSteps: [
			{
				target: '.tour-step-30',
				content: `Grazie per aver seguito tutta la Guida!<br><br>
						Ricorda che puoi riaprirla in ogni momento cliccando qui su "Mostra Guida".<br><br>
						Buon lavoro!`,
				params: {
					highlight: true,
					placement: 'bottom-end'
				},
				offset: 48
			}
		],
		
		bandoTourSteps: []
	},

	getters: {
		isRunning(state) {
			return state.isRunning;
		},
		showStep(state) {
			return state.showStep;
		},
		startManually(state) {
			return state.startManually;
		},
		
		introTourSteps(state) {
			return state.introTourSteps;
		},
		praticaINAILTourSteps(state) {
			return state.praticaINAILTourSteps;
		},
		praticaVIMTourSteps(state) {
			return state.praticaVIMTourSteps;
		},
		praticaVoucherCloudECybersecurityTourSteps(state) {
			return state.praticaVoucherCloudECybersecurityTourSteps;
		},
		praticaISMEATourSteps(state) {
			return state.praticaISMEATourSteps;
		},
		// contrattoDiServizioTourSteps(state) {
		// 	return state.contrattoDiServizioTourSteps;
		// },
		endTourSteps(state){
			return state.endTourSteps;
		},
		bandoTourSteps(state) {
			return state.bandoTourSteps;
		}
	},

	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
		SET_IS_RUNNING(state, boolean) {
			state.isRunning = boolean;
		},
		SET_SHOW_STEP(state, boolean) {
			state.showStep = boolean;
		},
		SET_START_MANUALLY(state, boolean) {
			state.startManually = boolean;
		},
		SET_BANDO_TOUR_STEPS(state, bandoTourSteps) {
			state.bandoTourSteps = bandoTourSteps;
		}
	},

	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
		composeBandoTourSteps({ commit, getters, rootGetters }) {
			let steps = [];
			const bandoId = rootGetters['shared/bando'].id;
			
			// nascondo due step se il cliente è un'azienda singola
			const tipologiaCliente = rootGetters['auth/user']?.cliente.tipologia;
			let filteredIntroTourSteps = [];
			if (tipologiaCliente === 'Azienda') {
				filteredIntroTourSteps = getters.introTourSteps.filter(
					step => step.target != '.tour-step-2'
						&& step.target != '.tour-step-4'
				);
			}
			else filteredIntroTourSteps = getters.introTourSteps;
			
			steps = filteredIntroTourSteps;
			
			// scelgo gli step della pratica in base al bando
			if (
				bandoId == 23
				|| bandoId == 26
				|| bandoId == 29
				|| bandoId == 31
			) steps = steps.concat(getters.praticaINAILTourSteps);
			else if (bandoId == 25) steps = steps.concat(getters.praticaVIMTourSteps);
			else if (bandoId == 28) steps = steps.concat(getters.praticaISMEATourSteps);
			else if (bandoId == 33) steps = steps.concat(getters.praticaVoucherCloudECybersecurityTourSteps);
			
			// steps = steps.concat(getters.contrattoDiServizioTourSteps);
			steps = steps.concat(getters.endTourSteps);
			
			commit('SET_BANDO_TOUR_STEPS', steps);
		}
	}
}

// export default {
// 	namespaced: true,
// 	state,
// 	getters,
// 	mutations,
// 	actions
// }